import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onSave", "onImageRemove"];
import { PopoverBodyMode } from '../../constants/popover';
//@ts-expect-error untyped module
import withLinkState from '../links/withLinkState';
import ImagePopoverBodyLite from './ImagePopoverBodyLite';
//@ts-expect-error untyped module
import ImagePopoverBodyEdit from './ImagePopoverBodyEdit';
import { jsx as _jsx } from "react/jsx-runtime";
function ImagePopoverBodyBranch(props) {
  const {
      mode = PopoverBodyMode.PREVIEW,
      onModeChange,
      onSave,
      onImageRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (mode === PopoverBodyMode.PREVIEW) {
    const handleEdit = () => {
      onModeChange(PopoverBodyMode.EDIT);
    };
    return /*#__PURE__*/_jsx(ImagePopoverBodyLite, Object.assign({}, rest, {
      onEdit: handleEdit,
      onRemove: onImageRemove
    }));
  }
  const handleSave = imageAttrs => {
    onModeChange(PopoverBodyMode.PREVIEW);
    onSave(imageAttrs);
  };
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  return /*#__PURE__*/_jsx(ImagePopoverBodyEdit, Object.assign({}, rest, {
    onSave: handleSave,
    onClose: handleClose
  }));
}
ImagePopoverBodyBranch.displayName = 'ImagePopoverBodyBranch';
export default withLinkState(ImagePopoverBodyBranch);